export const proficiencyLevelsDescription = [
  'Novice',
  'Advanced Beginner',
  'Practitioner',
  'Proficient',
  'Expert'
];
